module.exports = __webpack_public_path__ + "static/media/idcard.5b582799.png";